<template>
  <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.4854 0.460728C13.2206 0.195474 12.7909 0.195016 12.5261 0.459602L4.38771 8.57655L1.45139 5.38742C1.19766 5.112 0.768688 5.09414 0.492817 5.34783C0.217157 5.60155 0.199509 6.03074 0.453231 6.3064L3.86782 10.0147C3.99287 10.1506 4.16788 10.2296 4.35241 10.2334C4.35737 10.2336 4.36215 10.2336 4.3669 10.2336C4.54623 10.2336 4.71874 10.1624 4.84583 10.0357L13.484 1.42018C13.7495 1.15563 13.75 0.725981 13.4854 0.460728Z" class="icon-fill"/>
  </svg>



</template>

<script>
export default {
  name: 'check'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>